import actionTypes from '../../action-types'

export default (id) => ({
  type: actionTypes.USER.RELATIONS_FETCH,
  payload: {
    id,
  },
})
